class {
    onCreate() {
        this.state = {
            showSidebar: false
        }
    }

    toggleSidebar() {
        this.state.showSidebar = !this.state.showSidebar;
    }

    changePage(page) {
        window.location.href = page;
    }

    selectSidebarItem(event) {
        if(event.index === 0) {
            this.toggleSidebar();
            return;
        }

        this.changePage(this.input.pages[event.index-1].path);
    }
}

ui-sidebar overlay hidden=!state.showSidebar on-itemclick("selectSidebarItem")
    @item.sidebar-logo text="Hunter Stratton" icon="menu"
    for|page| of=input.pages||[]
        @item text=page.page secondary=input.currentpage===page.page.toLowerCase()